import Header from '@feature/Header'
import LoadingPopover from '@feature/LoadingPopover/LoadingPopover'
import PageContainer from '@feature/PageContainer'
import ProductSingle from '@feature/ProductSingle'
import ScrollToTop from '@feature/ScrollToTop'
import Search from '@feature/Search'
import Space from '@feature/Space'
import { useAppDispatch, useAppSelector } from 'app/hooks'
import { uriChanged } from 'app/search/searchSlice'
import { getSelectProductUri, selectBaseUri, selectSettingsLoaded, selectTaxonomyUris } from 'app/selectors'
import { initSettings } from 'app/thunks'
import React from 'react'
import { Redirect, Route, Switch, useLocation } from 'react-router'

function App() {
  const dispatch = useAppDispatch()

  //
  const settingsLoaded = useAppSelector(selectSettingsLoaded)
  const baseUri = useAppSelector(selectBaseUri)
  const { pathname } = useLocation()

  /**
   * Load the main app settings
   */

  React.useEffect(() => {
    dispatch(initSettings())
  }, [dispatch])

  React.useEffect(() => {
    if (settingsLoaded) dispatch(uriChanged(pathname))
  }, [dispatch, settingsLoaded, pathname])

  const taxonomyUris = useAppSelector(selectTaxonomyUris)

  const termRoutes = (Object.keys(taxonomyUris) as (keyof typeof taxonomyUris)[]).reduce((results, taxonomyId, i) => {
    const path = taxonomyUris[taxonomyId] ? `/${taxonomyUris[taxonomyId]}/:${taxonomyId}` : null
    return path ? results.concat(path) : results
  }, [] as string[])
  /**
   * Find the active term, if any, based on the current URI
   */
  // const activeTerm = useAppSelector(getSelectTermIdByUri(pathname))
  const productLink = useAppSelector(getSelectProductUri(`:slug`))

  /**
   * Find the active term, if any, based on the current URI
   */

  if (!settingsLoaded) {
    return <LoadingPopover />
  }

  return (
    <div className="App">
      <Header />
      <ScrollToTop />

      <PageContainer>
        <Space y="lg" />

        <Switch>
          <Route exact path={baseUri} component={Search} />
          <Route path={termRoutes} component={Search} />
          <Route exact path={productLink} component={ProductSingle} />
          <Redirect to={baseUri} />
        </Switch>

        <Space y="xl" />
      </PageContainer>
    </div>
  )
}

export default App
